//Material UI Components
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";

//Props Validations
import PropTypes from "prop-types";

// import mui icons
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

//utils
import { checkFilterSelection } from "../../utils/consumerFilterUtils";

//redux
import { useSelector, useDispatch } from "react-redux";
import { loadCurrentSelectedFiltersState, loadCurrentSelectedAllFiltersState, loadMissingFiltersState } from "store/features/consumerFilterSlice";
import { loadCurrentSelectedFiltersForCorrelationState, loadCurrentSelectedAllFiltersForCorrelationState, loadMissingFiltersForCorrelationState, loadWeightToggleForCorrelationState, loadDisableWeightToggleForCorrelationState } from "store/features/correlationSlice";
import { loadWeightToggleState, loadDisableWeightToggleState } from "store/features/analysisResultsSlice";
import { updateConsumerFilterValue } from "store/features/matchNetSlice";

const MissingFiltersDialog = ({
    productCode = "",
    currentFilterStoreData = {},
    setCurrentFilterStoreData = () => {},
    setCurrentFilterAllStoreData = () => {},
    handleFilterSubmit = () => {},
    missingFiltersDialogOpen,
    handleMissingFiltersDialogOpen = () => {},
    setOpen = () => {},
    missingFilters = {},
    allAnalysisData = [],
    type = "",
    studyTypeMethod = "",
    currentFilterAllStoreDataMatchNet = {},
    applicableProducts = [],
    moduleName = "",
    productsSecondaryData = [],
}) => {
    const dispatch = useDispatch();
    const missingFiltersStoreData = missingFilters;
    const dataMappingStoreData = useSelector((state) => state.dataMappingStore.displayLabelTranslation);
    const currentFilterAllStoreData = JSON.parse(JSON.stringify(useSelector((state) => state.consumerFilterStore.currentSelectedAllFilters)));
    const currentFilterAllStoreDataForCorrelation = JSON.parse(JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedAllFiltersForCorrelation)));
    const currentSelectedAllFilters = type === "correlation" ? currentFilterAllStoreDataForCorrelation : currentFilterAllStoreData;
    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);

    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);

    const getDisplayLabel = (backendVariable) => {
        const result = dataMappingStoreData[backendVariable];
        return result;
    };

    const renderMissingFilters = () => {
        return (
            <>
                {Object.keys(missingFiltersStoreData).map((product, i) => {
                    const missingFiltersData = missingFiltersStoreData[product].filters;
                    if (missingFiltersStoreData[product].isMissing === "true" && (moduleName !== "cross study comparison" || applicableProducts.includes(product))) {
                        return (
                            <Grid
                                container
                                spacing={4}
                                key={i}
                                style={{ paddingLeft: "50px" }}
                            >
                                <Grid
                                    item
                                    xs={6}
                                    style={{ fontSize: "0.75rem", textAlign: "left", fontWeight: "500", color: "#005eef", wordWrap: "break-word" }}
                                >
                                    {product
                                        .split("__")?.[0]
                                        .split("_")
                                        ?.filter((ele) => ele !== "")
                                        ?.join(" ")}{" "}
                                    / {selectedStudies?.find((study) => Number(study.id) === Number(product.split("__")[1]))?.study_reference__title}
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    {Object.keys(missingFiltersData).map((datum, i) => {
                                        const displayLabel = getDisplayLabel(datum);
                                        return (
                                            <div
                                                key={i}
                                                style={{ textAlign: "left" }}
                                            >
                                                <p style={{ fontWeight: "600", fontSize: "0.75rem" }}>{displayLabel}</p>
                                                <ul style={{ fontSize: "0.75rem" }}>
                                                    {missingFiltersData[datum].map((eachFilter, i) => {
                                                        return <li key={i}>{eachFilter.label}</li>;
                                                    })}
                                                </ul>
                                            </div>
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        );
                    }
                })}
            </>
        );
    };

    const handleMissingFiltersDialogueSubmit = async () => {
        if (type === "correlation") {
            dispatch(loadMissingFiltersForCorrelationState(missingFilters));
        } else if (moduleName === "cross study comparison") {
            dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "missingFilters",
                    value: structuredClone(missingFilters),
                })
            );
        } else {
            dispatch(loadMissingFiltersState(missingFilters));
        }
        const selectedProductFilters = currentFilterStoreData[productCode].filters;
        const checkedFilters = {};

        Object.keys(selectedProductFilters).forEach((filterCategory) => {
            const filterOptions = selectedProductFilters[filterCategory];
            const checkedOptions = filterOptions.filter((option) => option.checked === true);

            if (checkedOptions.length > 0) {
                checkedFilters[filterCategory] = checkedOptions;
            }
        });

        const checkedData = { ...currentFilterStoreData };
        Object.keys(currentFilterStoreData).map((item) => {
            if (moduleName === "cross study comparison") {
                const studyTypeMethodTitle = productsSecondaryData.find((datum) => {
                    const productCode = datum.title
                        .split(" ")
                        .filter((ele) => ele !== "")
                        .join("_");
                    return `${productCode}__${datum.coreDataId}` === item;
                })?.studyTypeMethodTitle;
                if (studyTypeMethodTitle !== studyTypeMethod) {
                    return;
                }
            }
            if (missingFiltersStoreData[item].isMissing === "false" || (missingFiltersStoreData[item].submitFlag && missingFiltersStoreData[item].filterVariant === "single") || moduleName === "cross study comparison") {
                const updatedFilters = { ...currentFilterStoreData[item].filters };
                for (const key of Object.keys(updatedFilters)) {
                    if (Object.keys(checkedFilters).includes(key)) {
                        const appliedFilters = checkedFilters[key];
                        const unAppliedFilters = updatedFilters[key];
                        const newArr = unAppliedFilters.map((obj2) => {
                            const matchingObj = appliedFilters.find((obj1) => obj1.value === obj2.value);
                            if (matchingObj) {
                                return { ...obj2, checked: true };
                            } else {
                                return { ...obj2, checked: false };
                            }
                        });
                        updatedFilters[key] = newArr;
                    } else {
                        const unAppliedFilters = updatedFilters[key];
                        const newArr = unAppliedFilters.map((obj2) => {
                            return { ...obj2, checked: false };
                        });
                        updatedFilters[key] = newArr;
                    }
                }
                if (moduleName === "cross study comparison") {
                    const studyTypeMethodTitle = productsSecondaryData.find((datum) => {
                        const productCode = datum.title
                            .split(" ")
                            .filter((ele) => ele !== "")
                            .join("_");
                        return `${productCode}__${datum.coreDataId}` === item;
                    })?.studyTypeMethodTitle;
                    if (studyTypeMethodTitle === studyTypeMethod) {
                        const finalFilters = {
                            ...currentFilterStoreData[item],
                            filters: updatedFilters,
                        };
                        checkedData[item] = finalFilters;
                    }
                } else {
                    const finalFilters = {
                        ...currentFilterStoreData[item],
                        filters: updatedFilters,
                    };
                    checkedData[item] = finalFilters;
                }

                Object.keys(updatedFilters).map((eachFilter) => {
                    const displayLabel = getDisplayLabel(eachFilter);
                    if (!updatedFilters[eachFilter].some((ele) => ele.checked === false)) {
                        if (currentSelectedAllFilters[item]) {
                            currentSelectedAllFilters[item].filters[displayLabel] = true;
                        }
                    } else {
                        if (currentSelectedAllFilters[item]) {
                            currentSelectedAllFilters[item].filters[displayLabel] = false;
                        }
                    }
                });
            } else {
                const updatedFilters = { ...currentFilterStoreData[item].filters };
                for (const key of Object.keys(updatedFilters)) {
                    const newArr = updatedFilters[key].map((obj2) => {
                        return { ...obj2, checked: false };
                    });
                    updatedFilters[key] = newArr;
                }
                const finalFilters = {
                    ...currentFilterStoreData[item],
                    filters: updatedFilters,
                };
                checkedData[item] = finalFilters;

                Object.keys(updatedFilters).map((eachFilter) => {
                    const displayLabel = getDisplayLabel(eachFilter);
                    if (!updatedFilters[eachFilter].some((ele) => ele.checked === false)) {
                        if (currentSelectedAllFilters[item]) {
                            currentSelectedAllFilters[item].filters[displayLabel] = true;
                        }
                    } else {
                        if (currentSelectedAllFilters[item]) {
                            currentSelectedAllFilters[item].filters[displayLabel] = false;
                        }
                    }
                });
            }
        });

        setCurrentFilterStoreData(checkedData);
        setCurrentFilterAllStoreData(currentSelectedAllFilters);
        if (type === "correlation") {
            dispatch(loadCurrentSelectedAllFiltersForCorrelationState(currentSelectedAllFilters));
            dispatch(loadCurrentSelectedFiltersForCorrelationState(checkedData));
        } else if (moduleName === "cross study comparison") {
            dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedAllFilters",
                    value: structuredClone(currentFilterAllStoreDataMatchNet),
                })
            );
            dispatch(
                updateConsumerFilterValue({
                    studyTypeMethodTitle: studyTypeMethod,
                    key: "currentSelectedFilters",
                    value: structuredClone(checkedData),
                })
            );
        } else {
            dispatch(loadCurrentSelectedAllFiltersState(currentSelectedAllFilters));
            dispatch(loadCurrentSelectedFiltersState(checkedData));
        }
        const pcs = [];
        Object.keys(currentFilterStoreData).forEach(async (item) => {
            const obj = missingFiltersStoreData[item];
            if (obj.isMissing === "false" || (obj.submitFlag && obj.filterVariant === "single")) {
                const datum = {
                    product: item.split("__")[0],
                    coreDataId: currentFilterStoreData[item].productCoreDataId,
                };
                pcs.push(datum);
                // handleFilterSubmit(item.split("__")[0], currentFilterStoreData[item].productCoreDataId, checkedData);
            }
        });
        // if (type === "correlation") {
        //     handleFilterSubmit(null, checkedData, missingFiltersStoreData);
        // } else {
        //     handleFilterSubmit(null, null, "consumerFilterAll", checkedData, pcs, null, allAnalysisData);
        // }
        if (type !== "correlation") {
            handleFilterSubmit({
                product: null,
                coreDataId: null,
                type: "consumerFilterAll",
                consumerFilter: checkedData,
                pcs,
                selectedStudy: null,
                allAnalysisData,
                fetchOnlyCurrent: false,
                boxAnalysisSelection: {
                    overall: overallBoxAnalysisSelection,
                    secondary: secondaryBoxAnalysisSelection,
                    agreement: agreementBoxAnalysisSelection,
                    claims: claimsBoxAnalysisSelection,
                },
                studyTypeMethod: studyTypeMethod,
            });
        }

        // added filter selection check and enable/disable weight toggle
        if (checkFilterSelection(checkedData)) {
            if (type === "correlation") {
                dispatch(loadWeightToggleForCorrelationState(false));
                dispatch(loadDisableWeightToggleForCorrelationState(true));
                handleFilterSubmit(null, checkedData, missingFiltersStoreData, false);
            } else {
                dispatch(loadWeightToggleState(false));
                dispatch(loadDisableWeightToggleState(true));
            }
        } else {
            const arr = [];
            selectedStudies.forEach((item) => {
                arr.push(item?.["weighted"]);
            });
            const flag = arr.some((ele) => ele === true);

            if (flag) {
                if (type === "correlation") {
                    dispatch(loadWeightToggleForCorrelationState(flag));
                    dispatch(loadDisableWeightToggleForCorrelationState(!flag));
                    handleFilterSubmit(null, checkedData, missingFiltersStoreData, flag);
                } else {
                    dispatch(loadWeightToggleState(flag));
                    dispatch(loadDisableWeightToggleState(!flag));
                }
            }
        }

        setOpen(false);
        handleMissingFiltersDialogOpen();
    };

    return (
        <Dialog
            open={missingFiltersDialogOpen}
            // onClose={missingFiltersDialogOpen}
            fullWidth={true}
            maxWidth="sm"
        >
            <DialogTitle
                style={{
                    color: "rgb(51, 94, 234)",
                    fontSize: 15,
                    textAlign: "center",
                    padding: "10px 12px",
                }}
                // className="liner-light-blue-background-2"
                id="alert-dialog-title"
            >
                <IconButton
                    aria-label="close"
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: "rgb(51, 94, 234) !important",
                    }}
                    onClick={handleMissingFiltersDialogOpen}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div
                    style={{
                        height: 500,
                        padding: "20px",
                        textAlign: "center",
                    }}
                >
                    <p
                        style={{
                            fontSize: "0.875rem",
                            fontWeight: "600",
                        }}
                    >
                        The filters you are trying to apply across products are missing in,
                    </p>
                    {renderMissingFilters()}
                </div>
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingBottom: "20px",
                }}
            >
                <p
                    style={{
                        fontSize: "0.75rem",
                        fontWeight: "600",
                        margin: "0px 100px",
                        textAlign: "center",
                        paddingBottom: "20px",
                    }}
                >
                    Would you still like to proceed (and have NA value on products where those filters are missing)?
                </p>
                <div>
                    <Button
                        size="small"
                        className="custom-btn custom-btn-outlined color-blue mx-2"
                        variant="outlined"
                        onClick={handleMissingFiltersDialogOpen}
                    >
                        Back
                    </Button>
                    <Button
                        size="small"
                        className="custom-btn custom-btn-outlined liner-light-blue-background mx-2"
                        sx={{ color: "#ffffff !important" }}
                        variant="outlined"
                        onClick={handleMissingFiltersDialogueSubmit}
                    >
                        Confirm
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

// Typechecking props for the missing filters tooltip
MissingFiltersDialog.propTypes = {
    productCode: PropTypes.string,
    currentFilterStoreData: PropTypes.object,
    setCurrentFilterStoreData: PropTypes.func,
    setCurrentFilterAllStoreData: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    missingFiltersDialogOpen: PropTypes.bool,
    handleMissingFiltersDialogOpen: PropTypes.func,
    setOpen: PropTypes.func,
    missingFilters: PropTypes.object,
    allAnalysisData: PropTypes.array,
    type: PropTypes.string,
    selectionData: PropTypes.object,
    studyTypeMethod: PropTypes.string,
    currentFilterAllStoreDataMatchNet: PropTypes.object,
    applicableProducts: PropTypes.array,
    moduleName: PropTypes.string,
    productsSecondaryData: PropTypes.array,
};

export default MissingFiltersDialog;
